import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import BookablePackageRate from '../../../../../models/BookablePackageRate';
import isEqual from "lodash/isEqual";
import { DETAIL_ACTIONS, PATHS, FEATURE_FLAGS, UPLOAD_DIRECTORY } from '../../../../../constants/Define';
import { cloneDeep, merge } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import RichTextEditor, { ClassicEditor } from "../../../common/component/RichTextEditor";
import Wrapper from '../../../common/component/Wrapper';
import { Icon, Input, Switch } from 'antd';
import './style.less';
import { LoadingComponent } from './../../../common/component/Index';
import UploadImage from '../../../common/component/UploadImage';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';

export default class BookablePackageRateDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            bookablePackageRate: new BookablePackageRate(),
            validation: {},
            thumbImage: {},
            isUpload: false
        };
    }

    onChange = (field, value) => {
        const bookablePackageRate = this.state.bookablePackageRate;
        bookablePackageRate[field] = field === "isActive"
            ? value
            : value ? value : field === "description" ? "<p></p>" : "";
        this.setState({ bookablePackageRate });
    };

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getBookablePackageRateDetail(match.params.id);
        this.props.getListAmenities();
    }

    onClickBack = () => {
        const { match } = this.props;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
                const path = Func.getPathWithParams(PATHS.BOOKABLE_PACKAGE_RATE.LIST.path, { hotel_id: match.params.hotel_id })
                this.props.history.push(path);
            }
        }
    }

    uploadFile = (file) => {
      let bookablePackageRate = this.state.bookablePackageRate;
      bookablePackageRate.imageLink = undefined;
      this.setState({
          isUpload: true,
          bookablePackageRate
      });
      this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.AMENITY, isFile: 1 });
    };

    removeThumbImage = () => {
      this.setState({
          bookablePackageRate: merge(this.state.bookablePackageRate, {
            imageLink: ""
          }),
          thumbImage: {},
      })
    }

    onShowTranslate = (language) => {
        const { bookablePackageRate } = this.state;
        bookablePackageRate.setTranslate(language.code);
        bookablePackageRate.setData();
        this.setState({ bookablePackageRate, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = (isUpdateTrans = false) => {
        const bookablePackageRate = cloneDeep(this.state.bookablePackageRate);
        const action = DETAIL_ACTIONS[bookablePackageRate.id ? 'UPDATE' : 'CREATE'];
        bookablePackageRate.setTranslate(undefined, true);
        bookablePackageRate.setData();
        this.setState({ bookablePackageRate, action });
    }

    selectFilterSearch = (input, option) => {
      const optionText = Func.vietnameseStringToUnicode((option?.props?.children[0] || '').toLowerCase());
      const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
      return optionText.indexOf(inputText) >= 0;
    }

    onSubmit = async (e) => {
        e.preventDefault();
        if(this.validate()){
          const { bookablePackageRate } = this.state;
          this.props.updateBookablePackageRate(bookablePackageRate.export(), bookablePackageRate.bookableId, {
            onSuccess: () => {
              this.props.getBookablePackageRateDetail(bookablePackageRate.bookableId);
            },
          });
          this.onExitTranslate();
        }
    }

    convertUrlImage(url) {
      return url.includes('https://') ? url : `https://${url}`
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.bookablePackageRateState.Detail && !isEqual(nextProps.bookablePackageRateState.Detail, this.props.bookablePackageRateState.Detail) && !nextProps.bookablePackageRateState.isFetching) {
            this.setState({
                bookablePackageRate: nextProps.bookablePackageRateState.Detail,
            });
        }
        this.setState({
          isUpload: nextProps.file.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
      // if (this.props.amenityState.detail.amenity !== prevProps.amenityState.detail.amenity) {
      //     let { thumbImageName, thumbImageView } = this.props.amenityState.detail.amenity;
      //     let amenity = this.props.amenityState.detail.amenity;
      //     this.setState({
      //         amenity: merge(amenity, {
      //             thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
      //             thumbImageView: thumbImageView
      //         }),
      //         thumbImage: thumbImageView || undefined,
      //     })
      // }
      if (this.props.file !== prevProps.file) {

          if (this.props.file.file) {
              let oldThumbImage = this.state.thumbImage;
              let thumbImageName = this.state.bookablePackageRate.imageLink ? this.state.bookablePackageRate.imageLink : "";
              if (this.props.file.file.type === 0) {
                  oldThumbImage = this.props.file.file.data;
                  thumbImageName = this.props.file.file.data.fileUrl;
              }
              this.setState({
                  file: this.props.file.file.type === 0 ? this.props.file.file : undefined,
                  bookablePackageRate: merge(this.state.bookablePackageRate, {
                    imageLink: thumbImageName,
                  }),
                  thumbImage: oldThumbImage || undefined,
              });
          }
      }
  }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                newName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.bookablePackageRate.newName`)),
                description: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.bookablePackageRate.description`)),
                languageCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`))
            }
        };
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.bookablePackageRate, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    render() {
        const { t, match, amenityState  } = this.props;
        const { amenities } = amenityState;
        const { action, bookablePackageRate, validation, isUpload } = this.state;

        return (
          <Fragment>
            <LoadingComponent spinning={this.props.bookablePackageRateState.isFetching || this.props.bookablePackageRateState.isUpdating}>
              <HMS.PageListComponent className="bookablePackageRate-detail">
                <HMS.HeaderListComponent
                  path={match.path}
                  groupPath={"bookable-package-rates"}
                  titleHeader={Func.capitalizeFirstLetter(
                    `${t(
                      action === DETAIL_ACTIONS.CREATE
                        ? "action.create"
                        : "action.update"
                    )} ${t("item.bookablePackageRate.title")}`.toLowerCase()
                  )}
                  componentRight={
                    FEATURE_FLAGS.TRANSLATE_ENABLE && (
                      <TranslateButton
                        languages={bookablePackageRate.translations}
                        current={bookablePackageRate.languageCode}
                        validation={validation.languageCode}
                        onChange={this.onShowTranslate}
                        onClear={this.onExitTranslate}
                        defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                        onSelectDefault={(language) =>
                          this.onChange({
                            name: "languageCode",
                            value: language.code,
                          })
                        }
                        disabledActionRemove
                      />
                    )
                  }
                />
                <HMS.FormActionComponent
                  onSubmit={this.onSubmit}
                  action={action}
                  isGetItem={false}
                  onClickBack={this.onClickBack}
                  backButtonText={
                    action === DETAIL_ACTIONS.TRANSLATE
                      ? t(`action.cancel`)
                      : t(`action.back`)
                  }
                  titleButtonSubmit={t(`action.save`)}
                  activeComponent={false}
                  submitButtonRight={true}
                >
                  <div className="basic-info">
                    <div className="basic-info-box">
                      <div className="row">
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={bookablePackageRate.name}
                            validation={validation.name}
                            labelTitle={t(`item.bookablePackageRate.name`)}
                          >
                            <Input
                              placeholder=""
                              type={`text`}
                              className={`form-control`}
                              name={`name`}
                              disabled
                              onChange={(e) =>
                                this.onChange("name", e.target.value)
                              }
                              value={Func.checkUndefine(
                                bookablePackageRate.name
                              )}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.code`)}
                          >
                            <Input
                              placeholder=""
                              type={`text`}
                              className={`form-control`}
                              name={`name`}
                              onChange={(e) =>
                                this.onChange("code", e.target.value)
                              }
                              disabled
                              value={Func.checkUndefine(
                                bookablePackageRate.code
                              )}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.refId`)}
                          >
                            <Input
                              placeholder=""
                              type={`text`}
                              className={`form-control`}
                              name={`name`}
                              onChange={(e) =>
                                this.onChange("refId", e.target.value)
                              }
                              disabled
                              value={Func.checkUndefine(
                                bookablePackageRate.refId
                              )}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.seq`)}
                          >
                            <Input
                              placeholder=""
                              type={`text`}
                              className={`form-control`}
                              name={`name`}
                              onChange={(e) =>
                                this.onChange("seq", Number(e.target.value))
                              }
                              disabled
                              value={bookablePackageRate.seq}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                          <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={bookablePackageRate.description}
                            validation={validation.description}
                            labelTitle={t(
                              `item.bookablePackageRate.description`
                            )}
                          >
                            <RichTextEditor
                                editor={ClassicEditor}
                                config={{ uploadDirectory: UPLOAD_DIRECTORY.HOTEL_THUMBS }}
                                data={Func.checkUndefine(bookablePackageRate.description)}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    return this.onChange("description", data)
                                }}
                            />
                            {/* <Input.TextArea
                              rows={3}
                              placeholder=""
                              type={`text`}
                              className="form-control"
                              name="description"
                              onChange={(e) =>
                                this.onChange("description", e.target.value)
                              }
                              value={bookablePackageRate.description}
                            /> */}
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={bookablePackageRate.newName}
                            validation={validation.newName}
                            labelTitle={t(
                              `item.bookablePackageRate.newName`
                            )}
                          >
                            <Input
                              rows={3}
                              placeholder=""
                              type={`text`}
                              className="form-control"
                              name="newName"
                              onChange={(e) =>
                                this.onChange("newName", e.target.value)
                              }
                              value={bookablePackageRate.newName}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(
                              `item.bookablePackageRate.transactionCode`
                            )}
                          >
                            <Input
                              rows={3}
                              placeholder=""
                              type={`text`}
                              className="form-control"
                              name="transactionCode"
                              value={bookablePackageRate.transactionCode}
                              disabled
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                      </div>
                      <div className="row">
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.thumbImage`)}
                          >
                            <UploadImage
                              // disabledUpload={action === DETAIL_ACTIONS.TRANSLATE}
                              multiple={false}
                              loading={isUpload}
                              thumbnailSize="100%"
                              buttonSize={120}
                              thumbnailStyle={{ maxHeight: 200 }}
                              uploadText={t('item.bookablePackageRate.uploadFile')}
                              loadingText={t('item.bookablePackageRate.uploading')}
                              onChange={this.uploadFile}
                              onRemoveThumbnail={this.removeThumbImage}
                              thumbnails={this.state.bookablePackageRate.imageLink ? [this.convertUrlImage(this.state.bookablePackageRate.imageLink)] : undefined}
                              />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.amenityId`)}
                          >
                            <AntSelect className="select-departure"
                                showArrow showSearch
                                // disabled={this.props.disabled}
                                suffixIcon={<Icon type="search" />}
                                name="amenityId"
                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.bundle.campaign")).toLowerCase()) }
                                onChange={ (e) => {
                                    this.onChange('amenityId', e);
                                } }
                                style={ { width: '100%' } }
                                value={bookablePackageRate.amenityId}
                                // loading={ isFetching }
                                filterOption={ (inputValue, option) => this.selectFilterSearch(inputValue, option) }
                            >
                                { (amenities || []).filter(item => item.isActive).map(a => (
                                    <AntOption key={ a.id } value={ a.id }>
                                       {a.name} &nbsp;&nbsp;{a.url && <img width={20} src={this.convertUrlImage(a.url)}/>}
                                    </AntOption>
                                )) }
                            </AntSelect>
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(
                              `item.bookablePackageRate.calculationRule`
                            )}
                          >
                            <Input
                              rows={3}
                              placeholder=""
                              type={`text`}
                              className="form-control"
                              name="calculationRule"
                              value={bookablePackageRate.calculationRule}
                              disabled
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-3">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(
                              `item.bookablePackageRate.postingRhythm`
                            )}
                          >
                            <Input
                              rows={3}
                              placeholder=""
                              type={`text`}
                              className="form-control"
                              name="postingRhythm"
                              value={bookablePackageRate.postingRhythm}
                              disabled
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-4">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.typeRate`)}
                          >
                            <br />
                            {/* {
                                                        bookablePackageRate.dc.map(typeId => <span key={typeId} ><HMS.StatusComponent color={HOTEL.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red' }
                                                        label={HOTEL.TYPE_RATE[CONFIG.ENV][typeId]}/></span>)
                                                    } */}
                            <span>
                              <HMS.StatusComponent
                                color={"red"}
                                label={t(`item.rate.filters.hotel`)}
                              />
                            </span>
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-4">
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.bookablePackageRate.isStatus`)}
                          >
                            <br />
                            <HMS.StatusComponent
                              color={
                                bookablePackageRate.isStatus ? "green" : "red"
                              }
                              label={
                                bookablePackageRate.isStatus
                                  ? t(
                                      "item.bookablePackageRate.active"
                                    )
                                  : t(
                                      "item.bookablePackageRate.deactive"
                                    )
                              }
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-4 m-t-sm">
                        {/* <Wrapper className="col-md-1"> */}
                          <HMS.FormWrapperInputComponent
                            labelTitle={t(
                              `item.bookablePackageRate.isActiveVPT`
                            )}
                            visible={!!bookablePackageRate.transactionCode}
                          >
                            <br />
                            <Switch
                              checked={bookablePackageRate.isActive}
                              onChange={(value) =>
                                this.onChange("isActive", value)
                              }
                              name={`isActive`}
                            />
                          </HMS.FormWrapperInputComponent>
                        </Wrapper>
                      </div>
                    </div>
                    {(action === DETAIL_ACTIONS.UPDATE) && (
                      <AutoTranslate
                        className="wrapper-full"
                        languageCode={bookablePackageRate?.languageCode || 'vi-VN'}
                        onChange={this.onChange}
                        targetLanguage={bookablePackageRate?.targetLanguage}
                      />
                    )}
                  </div>
                </HMS.FormActionComponent>
              </HMS.PageListComponent>
            </LoadingComponent>
          </Fragment>
        );
    }
}
